import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import { PropertySetsHttpService } from '../../../services/http/property-sets-http.service';

@Component({
  selector: 'miq-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: false,
})
export class SearchComponent implements OnInit {
  public searchControl = new UntypedFormControl();
  public textSearch: Observable<any[]> = of([]);

  @Input() userId: number;
  @Input() entity: string;
  @Input() filters: any[] = [];
  @Output() newRecord = new EventEmitter<any>();

  constructor(private propertySetsHttpService: PropertySetsHttpService) {}

  ngOnInit() {
    this.searchControl.valueChanges.pipe(debounceTime(500)).subscribe(this.search);
  }

  public search = (value: string) => {
    if (value.trim()) {
      this.textSearch = this.propertySetsHttpService
        .getPropertySetProperties(
          {
            entity: this.entity.toLowerCase(),
            userId: this.userId,
            query: value,
            filters: [
              {
                dataType: 'text',
                field: [],
                type: 'multifield',
                typeAhead: true,
                values: value.trim(),
              },
              {
                key: 16933,
                type: 'equal',
                field: 'miq_record_hide_f',
                dataType: 'boolean',
                name: 'Hidden Properties',
                values: false,
              },
              ...this.filters,
            ],
          },
          10
        )
        .pipe(map(({ results }) => results));
    } else {
      this.textSearch = of([]);
    }
  };

  public addRecord(usageId: number) {
    this.searchControl.setValue('');
    this.textSearch = of([]);
    this.newRecord.emit(usageId);
  }
}
